module.exports = __webpack_public_path__ + "static/media/danskeheadlinebold-webfont.7d51ee04.ttf";